// This function matches quick_view_render_scale() in MMS - algolia_helper.rb
const getQuickViewRenderScale = (style) => {
  const mmsScale = style.views[0].scale;
  if (mmsScale && !Number.isNaN(mmsScale)) {
    const scalePercentage = Math.floor(7200 / mmsScale);
    return `${mmsScale} (${scalePercentage}%)`;
  }
  return 'n/a';
};

export default getQuickViewRenderScale;
